import React from 'react';
import {connect} from "react-redux";
import PublicLayout from "../Public";
import {Button, Col, Form, Input, Row} from "antd";
import language from "../../languages/language";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import TitleAndInfo from "../TitleAndInfo/TitleAndInfo";
import advlogin from "../../actions/advlogin";
import isLoggedIn from "../../actions/isLoggedIn";

class AdvisorLogin extends React.Component
{
    componentDidMount()
    {
        this.props.isLoggedIn();
    }

    render()
    {
        const span=18;
        return <PublicLayout title={'logo'} size={'small'}>
            <TitleAndInfo info={language[this.props.language].userExistsInfo}/>
            <Form ref={this.formRef} onFinish={this.props.advlogin} className={'regularForm'}>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="userName"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input autoComplete={'username'} placeholder={language[this.props.language].userLabel}
                                   size={'large'} className={'mb-10'}
                                   prefix={<UserOutlined style={{color: 'rgba(0,0,0,.25)'}} />}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item name="password"
                                   rules={[{required: true,
                                       message: language[this.props.language].requiredError }]}>
                            <Input.Password autoComplete="new-password" placeholder={language[this.props.language].passwordLabel}
                                   size={'large'} className={'mb-10'}
                                            prefix={<LockOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item className={'text-center'}>
                            <Button type="primary light-blue rounded" htmlType="submit">
                                {language[this.props.language].nextLabel}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </PublicLayout>;
    }
}
function mapStateToProps(state) {
    return {
        language: state.auth.language
    }
}
export default connect(mapStateToProps, {advlogin,isLoggedIn})(AdvisorLogin);